





import { Vue, Prop, Component } from 'vue-property-decorator';
import OldModal from '@/modal/components/OldModal.vue';

@Component({
  components: {
    OldModal,
  },
})
export default class UnsupportedBrowserModal extends Vue {
  @Prop() isVisible: boolean;

  close() {
    this.$emit('close');
  }
}
